import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { T5Report } from "../../../components/Reports/T5Report";

export interface IT5ReportPage {}

export const T5ReportPage: FC<IT5ReportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="T5 Report"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<T5Report />}
    />
  );
};
